var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refresh-load"},[_c('div',{staticClass:"spinner"},_vm._l((_vm.rectlist),function(item){return _c('div',{key:item,class:`rect${item}`,style:({'background-color': _vm.color})})}),0),(_vm.text)?_c('div',{staticClass:"spinner-text",style:({'color': _vm.textColor})},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }